<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem prop="name" :label="$t( 'resourceLifecycle.bucketName' )" >
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>
    <Row>
      <Col span="11">
        <FormItem prop="copySettings" :label="$t( 'resourceLifecycle.copysettingsfromanexistingbucket' )" >
          <Select v-model="resourceApplicationForm.copySettings" filterable>
            <Option :value="item.name" v-for="(item,index) in copySettingsList"
                    v-bind:key="item.name">{{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AmazonObjectStorage',
    props: ['amazonResourceApplicationBasicInfoForm'],
    components: {},
    data() {
      return {
        copySettingsList: [],
        resourceApplicationForm: {
          name: '',
          copySettings: '',
          cost: 0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.bucketnamecannotbeempty' ), trigger: 'blur'}
          ],
          copySettings: [
            {required: true, message: this.$t( 'resourceLifecycle.pleasechoosetocopysettingsfromanexistingbucket' ), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      showAll: function () {
        //查询存储桶
        this.queryAWSBucketList();
        this.queryAWSS3Price();
      },
      //查询价格
      queryAWSS3Price: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.amazonResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        }
        this.$api.awsPrice.queryAWSS3Price(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      //查询AWS可用区
      queryAWSBucketList: function () {
        this.$api.lifecycleResourceApplication.queryAWSBucketList({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if (res.data) {
              this.copySettingsList = res.data;
            }

          })
      },
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/object_storage/AmazonObjectStorage.vue